import { getCookie } from '@mirai/data-sources';

import { COOKIE_BANNERS, DENIED, GRANTED } from '../CookieBanner.constants';

export const getExternalCookie = () => {
  let accepted;
  COOKIE_BANNERS.forEach((name) => {
    const value = getCookie(name);
    if (value !== undefined) {
      const decodedValue = decodeURIComponent(value);
      accepted =
        decodedValue.includes('statistics:true') ||
        decodedValue.includes('marketing:true') ||
        decodedValue.includes('"thirdparty":"1"') ||
        decodedValue.includes('"advanced":"1"') ||
        value.includes('analytics:yes') ||
        value.includes('advertisement:yes') ||
        value === 'allow';
    }
  });

  return accepted !== undefined ? (accepted ? GRANTED : DENIED) : undefined;
};
